const $ = require('jquery');
const offcanvasdialog = require('../components/offcanvasdialog');
const bopisTracking = require('../components/tracking/bopis');

/**
 * Using google geocode to get coordinate from search text, show stores following this coordinate
 *
 * @param {string} searchString Search string customer entered
 * @param {number} radius Radius within which the store is available
 * @returns {void}
 */
function getSearchResults(searchString, radius) {
    const googleMaps = window.google.maps;
    const geocoder = new googleMaps.Geocoder();
    const storecountry = $('#pdp-store-country').val();

    let locationParams = {};

    geocoder.geocode(
        {address: searchString, componentRestrictions: {country: storecountry}},
        function (results, status) {
            if (status === 'OK' && results.length >= 1) {
                const firstResult = results[0];
                // If result is valid, address_components will always have lenght over 1
                if (firstResult.address_components.length > 0) {
                    const location = {
                        lat: firstResult.geometry.location.lat(),
                        long: firstResult.geometry.location.lng()
                    };

                    const {lat, long} = location;

                    locationParams = {
                        radius,
                        lat,
                        long
                    };
                    ajaxFetchStore(locationParams);
                }
            } else {
                locationParams = {
                    radius,
                    lat: 0,
                    long: 0
                };
                ajaxFetchStore(locationParams);
            }
        }
    );
}

/**
 * Detect the location of the customer using geolocation
 *
 * @returns {void}
 */
function detectLocation() {
    if (!navigator.geolocation) {
        return;
    }

    const that = $;
    navigator.geolocation.getCurrentPosition(function (position) {
        const radius = that('#radius').val();
        const locationParams = {
            radius,
            lat: position.coords.latitude,
            long: position.coords.longitude
        };
        ajaxFetchStore(locationParams);
    });
}

/**
 * Fetch stores that are within the location details
 *
 * @param {Object} locationParams lat and long position of location
 * @returns {void}
 */
function ajaxFetchStore(locationParams) {
    const url = $('#bopisresources').data('storesearchurl');
    $.ajax({
        type: 'GET',
        url: `${url}?latitude=${locationParams.lat}&longitude=${locationParams.long}&radius=${locationParams.radius}`,
        dataType: 'html',
        /**
         * @param {string} response - response
         */
        success(response) {
            const res = $(response);
            if (res.hasClass('message error-form')) {
                $('.pdp-nostore-found').empty();
                $('.pdp-nostore-found').append(response);
            } else {
                $('.pdp-store-list').replaceWith(response);
            }
        }
    });
}

/**
 * Sets the customers current store that they selected
 *
 * @param {string} StoreID the store ID to set
 * @param {jQuery} $triggerButton the trigger button
 * @returns {void}
 */
function ajaxSetStore(StoreID, $triggerButton) {
    const $rowProduct = $triggerButton.parents('.row-product');
    const LineItemID = $rowProduct ? $rowProduct.data('uuid') : null;
    const pid = $rowProduct ? $rowProduct.find('input[name="minicartPid"]').val() : null;
    const url = $('.bopis-pdp-container').attr('set-store');
    const param = {
        StoreID,
        LineItemID: LineItemID || null,
        pid: pid || null
    };

    $.post(url, param).done(function (res) {
        if (res.isStoreUpdated) {
            window.location.reload(res.cartURL);
        }
    });
}

/**
 * Load bopis content based on position
 *
 * @param {Object} position current position of user
 * @returns {void}
 */
function loadBopis(position) {
    let url = $('.bopis-pdp-container').data('url');
    const {latitude, longitude} = position.coords;
    const isSameGeolocation = checkGeolocationChange(latitude, longitude);

    if (!isSameGeolocation) {
        url += `?pid=${$('.bopis-pdp-container').data('pid')}&latitude=${latitude}&longitude=${longitude}`;

        $.ajax({
            type: 'GET',
            url,
            dataType: 'html',
            /**
             * @param {string} response - response
             */
            success(response) {
                $('.bopis-pdp-container').empty().append(response);
            }
        });
    }
}

/**
 *
 * @param {number} latitude - The current latitude according to navigator
 * @param {number} longitude - The current longitude according to navigator
 * @returns {boolean} whether geolocation has changed
 */
function checkGeolocationChange(latitude, longitude) {
    // Either get the sessionStorage geolocation or just create an empty object.
    const sessionGeolocation = JSON.parse(sessionStorage.geolocation || '{}');
    const isSameGeolocation =
        !!sessionGeolocation.latitude &&
        sessionGeolocation.latitude === latitude &&
        sessionGeolocation.longitude === longitude;

    /* If we have the same geolocation but the container's html is empty,
        we might want to still try rendering, as new stores might've been added. */
    if (isSameGeolocation && $('.bopis-pdp-container').html() !== '') {
        return true;
    }

    sessionStorage.geolocation = JSON.stringify({
        latitude,
        longitude
    });

    return false;
}

/**
 *
 */
exports.init = function () {
    const storeLocatorFlyin = offcanvasdialog.init(
        'flyin-store-finder',
        {
            // eslint-disable-line no-unused-vars
            overlay: true,
            reloadContentAlways: true,
            additionalClass: '',
            closeOnX: true
        },
        function ($triggerButton) {
            $('body').on('click', '#pdp-current-location', function () {
                detectLocation();
            });

            $('#pdp-store-btn-search, .flyin-icon-search').on('click', function (e) {
                e.preventDefault();
                $('.pdp-nostore-found').empty();
                $('.pdp-store-list').empty();
                const searchString = $('.pdp-flyin-tb').val();
                const radius = $('#radius').val();
                if (searchString.length > 0) {
                    getSearchResults(searchString, radius);
                }
                bopisTracking.recordFindStoreClick();
            });

            $('body').on('click', '.pdp-store-label', function (e) {
                e.preventDefault();
                $('.pdp-store-label').removeClass('active');
                $(this).addClass('active');
            });

            $('body').on('click', '.store-select-radio', function () {
                const currentRadio = this.checked;
                if (currentRadio) {
                    $('.selected-store-value').val(this.value);
                    $('#selectd-store-id').val($(this).data('selected-storeid'));
                }
            });

            $('body').on('click', '.flyin-btn-close', function () {
                $('input[name="store-list"]:checked').trigger('click');
                $('.closest-store').html($('.selected-store-value').val());

                const StoreID = $('input[name="store-list"]:checked').attr('data-selected-storeid');
                ajaxSetStore(StoreID, $triggerButton);

                bopisTracking.recordConfirmStoreClick();

                storeLocatorFlyin.hide();
                $('.ocd-overlay .icon-close').trigger('click');
                $('.ocd-overlay').removeClass('active');
            });

            $('body').on('click', '#radius', function () {
                document.getElementsByClassName('arrow')[0].classList.toggle('arrow-active');
            });
        }
    );

    $('body').on('click', 'button.btn-bopis', function () {
        const btnEle = $(this);
        const isPickUp = btnEle.hasClass('btn-pick-up');

        if (btnEle.hasClass('unselectable')) return false;

        $('button.btn-bopis').removeClass('selected');
        btnEle.addClass('selected');
        $('.reminder.bopis').addClass('reminder-hidden');
        $('.is-pickup').val(btnEle.hasClass('btn-pick-up'));

        // Show/Hide Gift options on PDP
        if (isPickUp) {
            $('#apple-pay-pdp-button').addClass('apple-pay-hidden');
            $('#google-pay-pdp-button').addClass('google-pay-hidden');

            // Trigger the browser geolocation check
            navigator.geolocation.getCurrentPosition(loadBopis);
        } else {
            $('#apple-pay-pdp-button').removeClass('apple-pay-hidden');
            $('#google-pay-pdp-button').removeClass('google-pay-hidden');
        }

        bopisTracking.recordPDPClick(isPickUp);
    });

    $(document).ready(function () {
        const $bopisContainer = $('.bopis-pdp-container');

        // Move reminder section under the BOPIS controls if they are shown
        if ($bopisContainer.length && !$bopisContainer.is(':empty')) {
            $('.product-reminder-section').insertAfter($bopisContainer);
        }
    });

    $('body').on('verifyShippingOptions', function (e, checkBopisStatus) {
        if ($('.btn-bopis.selected').length > 0) {
            checkBopisStatus.allow = true;
            $('.reminder.bopis').addClass('reminder-hidden');
        } else {
            checkBopisStatus.allow = false;
            $('.reminder.bopis').removeClass('reminder-hidden');
        }
    });
};
